import * as bp from "@ecologi/react-components/src/theme/ecologi-breakpoints";
import { User } from "@ecologi/shared";
import styled from "@emotion/styled";
import React from "react";
import { Button } from "../Button";

export type BannerWithMobileProps = {
  title: string;
  description_sign_in: string;
  description_sign_out: string;
  button_text_sign_in: string;
  button_text_sign_out: string;
  mobile_image: string;
  user: User;
};

const MW_1050 = `only screen and (min-width: 1050px)`;
const MW_1160 = `only screen and (min-width: 1160px)`;
const MW_1390 = `only screen and (min-width: 1390px)`;
const MW_1360 = `only screen and (min-width: 1360px)`;
const MAXW_1049 = `only screen and (max-width: 1049px)`;

export const BannerWithMobile = (props: BannerWithMobileProps) => {
  return (
    <Wrapper>
      <Container isUser={!!props.user}>
        <ImageWrapper>
          <Image src={props.mobile_image} />
        </ImageWrapper>
        <Grid>
          <ContentContainer>
            <Title>{props.title}</Title>
            {props.user ? (
              <DescriptionWrapper>
                {props.description_sign_in}
              </DescriptionWrapper>
            ) : (
              <DescriptionWrapper>
                {props.description_sign_out}
              </DescriptionWrapper>
            )}
            <ButtonWrapper
              lightGreen
              text={
                props.user
                  ? props.button_text_sign_in
                  : props.button_text_sign_out
              }
              href={props.user ? "/impact-shop" : "/plan"}
            />
          </ContentContainer>
        </Grid>
      </Container>
    </Wrapper>
  );
};

const DescriptionWrapper = styled.div`
  color: ${(props) => props.theme.colors.charcoal};

  line-height: 28px;
  margin-bottom: 32px;
  font-size: 18px;
  text-align: center;

  @media ${(props) => props.theme.bp.desktopUp} {
    text-align: left;
  }

  a {
    color: black;
  }
`;

const Wrapper = styled.div`
  overflow: hidden;
  background-color: ${(props) => props.theme.colors.forest};
`;

const ButtonWrapper = styled(Button)`
  @media ${MAXW_1049} {
    padding: 0 24px;
    margin: 0 auto;
    width: fit-content;
  }
`;

const Image = styled.img`
  width: 100%;
`;

const ImageWrapper = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  line-height: 0px;

  @media ${MW_1050} {
    width: 580px;
  }

  @media ${MW_1160} {
    width: 650px;
  }

  @media ${MW_1360} {
    width: 700px;
    margin-right: 15px;
  }

  @media ${MW_1390} {
    margin-right: 55px;
  }

  @media ${MAXW_1049} {
    position: relative;
    margin: 0;
    width: 80%;
  }

  @media ${bp.mobileDown} {
    width: 100%;
  }
`;

const ContentContainer = styled.div`
  background-color: ${(props) => props.theme.colors.snowdrop};
  display: flex;
  flex-direction: column;
  padding: 40px 24px;

  @media ${(props) => props.theme.bp.mobileDown} {
    padding: 40px 24px;
  }

  @media ${(props) => props.theme.bp.tabletUp} {
    padding: 30px 60px;
  }

  @media ${MW_1050} {
    display: block;
    margin-left: 65px;
    margin-top: 0;
    max-width: 400px;
    padding: 25px 65px 40px 40px;
  }

  @media ${MW_1160} {
    max-width: 450px;
    padding: 45px 65px 60px 40px;
  }

  @media ${MW_1360} {
    max-width: 585px;
  }
`;

const Container = styled.div<{ isUser?: boolean }>`
  position: relative;
  max-width: 1600px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  padding: 50px 0;
  min-height: 532px;

  @media ${MAXW_1049} {
    flex-direction: column;
    padding: 0;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  flex-grow: 1;
  position: relative;
  z-index: 10;

  @media ${MW_1050} {
    grid-template-columns: 1fr 1fr;
  }
`;

const Title = styled.h2`
  color: ${(props) => props.theme.colors.charcoal};
  font-size: 26px;
  font-weight: bold;
  letter-spacing: 0px;
  line-height: 1.2;
  text-align: center;
  margin: 0 20px 16px 20px;

  @media ${(props) => props.theme.bp.tabletUp} {
    font-size: 32px;
    margin: 0 0 16px 0;
  }

  @media ${MW_1050} {
    text-align: left;
  }
`;
